import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

function PrivateRoutes() {
  // Assuming you want to redirect to "/site" when not logged in
  const isLogged = localStorage.getItem('logado') === 'S'

  return isLogged ? <Outlet /> : <Navigate to="/site" />
}

export default PrivateRoutes
